/**
 * Test File: Simple Tailwind Styling Verification
 * Created: 2025-09-23
 * Status: Permanent
 * Dependencies: Tailwind CSS
 * Cleanup Condition: Keep - Core styling verification
 */

import React from 'react';

const SimpleTest: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">Simple Test Page</h1>
        <p className="text-gray-600 dark:text-gray-300 mb-6">
          This is a simple test page to verify the app is working.
        </p>

        <div className="space-y-4">
          <div className="p-4 bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-md">
            <h2 className="text-lg font-semibold text-green-800 dark:text-green-200">
              ✅ React is working
            </h2>
            <p className="text-green-700 dark:text-green-300">
              If you can see this page, React is rendering correctly.
            </p>
          </div>

          <div className="p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-md">
            <h2 className="text-lg font-semibold text-blue-800 dark:text-blue-200">
              🎨 Tailwind CSS is working
            </h2>
            <p className="text-blue-700 dark:text-blue-300">
              The styling on this page confirms Tailwind CSS is loaded.
            </p>
          </div>

          <div className="p-4 bg-purple-50 dark:bg-purple-900/20 border border-purple-200 dark:border-purple-800 rounded-md">
            <h2 className="text-lg font-semibold text-purple-800 dark:text-purple-200">
              🔗 Routing is working
            </h2>
            <p className="text-purple-700 dark:text-purple-300">
              You accessed this page via the router, so React Router is functioning.
            </p>
          </div>

          <button
            onClick={() => alert('JavaScript is working!')}
            className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700 transition-colors"
          >
            Test JavaScript
          </button>
        </div>
      </div>
    </div>
  );
};

export default SimpleTest;
